import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { cancelCreateCalculation, createCalculation } from '../../modules/calculation';

import { buildUIStringArray } from '../../utils/index';

class CreateCalculationDialog extends React.Component {

  state = {
    newName: 'Name'
  }

  initName = (value) => {
    this.state.name = value;
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  onKeyPress = event => {
    if(event.which === 13) {
      const { onCreateCalculation } = this.props;
      if( onCreateCalculation ) {
        onCreateCalculation(this.state.name);
      }
    }
  }

  render() {
    const { project, onCreateCalculation, onCancelCreateCalculation, app, translations, ...other } = this.props;

    let ui = buildUIStringArray(app.language, translations.data);

    // onRequestClose laukaistaan kun klikataan dialogin ulkopuolella
    return (
      <Dialog
        onClose={onCancelCreateCalculation}
        TransitionProps={{
          onEnter: app.calculationCreateDialogOpen
            ? null
            : this.initName(ui['CALCULATION-DEFAULT_NAME'] + ' ' + (project.calculations.length + 1))
        }}
        {...other}
      >
        <DialogTitle>{ui['GENERAL-ENTER_NAME_FOR_NEW_CALC']}</DialogTitle>
        <DialogContent>
          <TextField
            label={ui['GENERAL-NAME']}
            value={ this.state.name || '' }
            onChange={this.handleChange('name')}
            onKeyPress={this.onKeyPress.bind(this)}
            margin="normal"
            autoFocus
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancelCreateCalculation} color="primary">
            {ui['GENERAL-CANCEL']}
          </Button>
          <Button onClick={onCreateCalculation.bind(this, this.state.name)} color="primary" autoFocus>
            {ui['CALCULATION-CREATE']}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

CreateCalculationDialog.propTypes = {
    project: PropTypes.object,
  onCreateCalculation: PropTypes.any,
  onCancelCreateCalculation: PropTypes.any,
  app: PropTypes.any,
  translations: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      app: state.app,
      project: state.project,
      translations: state.translations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCancelCreateCalculation: index => dispatch(cancelCreateCalculation()),
      onCreateCalculation: name => dispatch(createCalculation({ name: name, type: 'plane' })),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CreateCalculationDialog);
